<template>
    <div class="back-perfil">
        <div class="container pb-5 px-2">
            <div class="criar-conta mt-5">
                <h2 class="text-center text-white"><strong>Meus Dados</strong></h2>

                <div class="dados-conta bg-white mt-5 mt-md-3 rounded p-2 shadow">
                    <div class="font-cna my-0 mx-auto m-md-3">
                        <div class="media">
                            <!--<div class="img-edit mr-md-3 text-center text-md-left">

                                              <label for="selecao-arquivo">
                                                  <img class="mr-3 img-thumbnail rounded-circle shadow" v-if="model.foto" :src="model.foto" />
                                                  <img class="mr-3 img-thumbnail rounded-circle shadow" v-if="!model.foto" src="../../assets/images/avatar-none.png" />
                                              </label>

                                              <b-form-file id="selecao-arquivo" ref="file" name="foto" class="form-control" v-model="foto" accept="image/*" v-on:change="validaTamanho()" style="display:none;"></b-form-file>

                                              <div class="btn-img text-center text-primary">
                                                  <label for="selecao-arquivo" v-b-tooltip.hover title="Alterar Imagem">
                                                      <i class="far fa-images"></i>
                                                  </label>
                                                  |
                                                  <label v-b-tooltip.hover title="Remover Imagem" @click="model.foto = null">
                                                      <i class="fas fa-times"></i>
                                                  </label>
                                              </div>

                                          </div>-->
                            <div class="media-body pr-md-4">
                                <h4 class="mt-0 text-primary text-center">{{ model.nome }}</h4>
                                <hr class="mb-0" />
                                <form ref="pessoa-cna-form-edit"
                                      v-on:submit.prevent="executeEdit(model)"
                                      novalidate
                                      class="form-group mt-3">
                                    <div>
                                        <b-tabs>
                                            <b-tab title="Meus Dados" active>
                                                <div class="mt-3">
                                                    <div class="editando-perfil w-100">
                                                        <div class="ml-md-3">
                                                            <h6>DADOS PESSOAIS</h6>
                                                        </div>

                                                        <div class="row pl-md-3">
                                                            <div class="form-group form-group-custom col-md-12">
                                                                <label for="nome" class="bmd-label-floating">Nome Completo</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           name="nome"
                                                                           autocomplete="off"
                                                                           v-model="model.nome" />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.nome}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="email" class="bmd-label-floating">E-mail</label>
                                                                <p>{{ model.email }}</p>
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="emailAlternativo"
                                                                       class="bmd-label-floating">E-mail alternativo</label>
                                                                <p>{{ model.emailAlternativo }}</p>
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="cpF_CNPJ" class="bmd-label-floating">CPF ou CNPJ</label>
                                                                <p>{{ model.cpF_CNPJFormatado }}</p>
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="rG_IE" class="bmd-label-floating">RG</label>
                                                                <the-mask name="rG_IE"
                                                                          class="form-control"
                                                                          :mask="'##.###.###-X'"
                                                                          v-model="model.rG_IE" />
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-12">
                                                                <span class="text-primary text-sm-left font-italic">
                                                                    *O e-mail e CPF são utilizados para realizar
                                                                    o acesso ao Shopping CNA. Para alterar o seu
                                                                    e-mail vá até a aba DADOS DE ACESSO
                                                                </span>
                                                            </div>

                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="apelido" class="bmd-label-floating">Apelido</label>
                                                                <input type="text"
                                                                       class="form-control"
                                                                       name="apelido"
                                                                       autocomplete="off"
                                                                       v-model="model.apelido" />
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="celular" class="bmd-label-floating">Celular</label>
                                                                <input type="text"
                                                                       v-mask="'(##) #####-####'"
                                                                       maxlength="15"
                                                                       class="form-control"
                                                                       name="celular"
                                                                       autocomplete="off"
                                                                       v-model="model.celular" required />
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="comercial"
                                                                       class="bmd-label-floating">Telefone Comercial</label>
                                                                <input type="text"
                                                                       v-mask="'(##)####-####'"
                                                                       maxlength="14"
                                                                       class="form-control"
                                                                       name="comercial"
                                                                       autocomplete="off"
                                                                       v-model="model.telefoneComercial" />
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="telefone" class="bmd-label-floating">Telefone</label>
                                                                <input type="text"
                                                                       class="form-control"
                                                                       name="telefone"
                                                                       v-mask="'(##) ####-####'"
                                                                       maxlength="14"
                                                                       autocomplete="off"
                                                                       v-model="model.telefone" />
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-4">
                                                                <label for="dtNascimento"
                                                                       class="bmd-label-floating">Data Nascimento</label>
                                                                <input type="text"
                                                                       v-datepicker
                                                                       v-mask="'##/##/####'"
                                                                       class="form-control"
                                                                       maxlength="10"
                                                                       name="dataNascimento"
                                                                       autocomplete="off"
                                                                       v-model="model.dataNascimento" />
                                                            </div>
                                                            <div class="form-group col-md-8">
                                                                <label>Sexo</label>
                                                                <div class="form-group">
                                                                    <div class="btn-group btn-group-toggle genero w-100">
                                                                        <label class="btn bg-light radius-left px-2 text-primary"
                                                                               v-bind:class="{ active: model.sexo == 1 }">
                                                                            <input type="radio"
                                                                                   id="sexo-1"
                                                                                   name="sexo"
                                                                                   v-model="model.sexo"
                                                                                   value="1" />
                                                                            <i class="fas fa-male"></i> Masculino
                                                                        </label>
                                                                        <label class="btn bg-light px-2 text-primary"
                                                                               v-bind:class="{ active: model.sexo == 2 }">
                                                                            <input type="radio"
                                                                                   id="sexo-0"
                                                                                   name="sexo"
                                                                                   v-model="model.sexo"
                                                                                   value="2" />
                                                                            <i class="fas fa-female"></i> Feminino
                                                                        </label>
                                                                        <label class="btn bg-light radius-right px-2 text-primary"
                                                                               v-bind:class="{
                                        active: model.sexo == null,
                                      }">
                                                                            <input type="radio"
                                                                                   id="sexo-null"
                                                                                   name="sexo"
                                                                                   v-model="model.sexo"
                                                                                   value="null" />
                                                                            Não informar
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="">
                                                    <div class="editando-perfil w-100 mt-md-3">
                                                        <div class="ml-md-3">
                                                            <h6>ENDEREÇO</h6>
                                                        </div>

                                                        <div class="row pl-md-3">
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="cep" class="bmd-label-floating">CEP</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           name="cep"
                                                                           autocomplete="off"
                                                                           v-mask="'#####-###'"
                                                                           maxlength="9"
                                                                           v-model="model.cep"
                                                                           @change="buscarCep()" minlength="9" required />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.cep}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="rua" class="bmd-label-floating">Rua</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           name="rua"
                                                                           autocomplete="off"
                                                                           v-model="model.rua"
                                                                           maxlength="255" minlength="2" required @keypress="textoPadrao($event)" onpaste="return false" />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.rua}}</p>
                                                                </div>

                                                            </div>
                                                            <div class="form-group form-group-custom col-md-3">
                                                                <label for="numero" class="bmd-label-floating">Número</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="number"
                                                                           class="form-control"
                                                                           name="numero"
                                                                           autocomplete="off"
                                                                           v-model="model.numero"
                                                                           maxlength="15" minlength="1" required />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.numero}}</p>
                                                                </div>

                                                            </div>
                                                            <div class="form-group form-group-custom col-md-3">
                                                                <label for="complemento"
                                                                       class="bmd-label-floating">Complemento</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           name="complemento"
                                                                           autocomplete="off"
                                                                           v-model="model.complemento"
                                                                           maxlength="50" @keypress="textoPadrao($event)" onpaste="return false" />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.complemento}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="bairro" class="bmd-label-floating">Bairro</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           name="bairro"
                                                                           autocomplete="off"
                                                                           v-model="model.bairro"
                                                                           maxlength="50" minlength="2" required @keypress="textoPadrao($event)" onpaste="return false" />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.bairro}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="cidade" class="bmd-label-floating">Cidade</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           name="cidade"
                                                                           autocomplete="off"
                                                                           v-model="model.cidade"
                                                                           maxlength="50" minlength="2" required @keypress="textoPadrao($event)" onpaste="return false" />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.cidade}}</p>
                                                                </div>

                                                            </div>
                                                            <div class="form-group form-group-custom col-md-6">
                                                                <label for="uf" class="bmd-label-floating">UF</label>
                                                                <div v-if="!bloquearEscolaCNAStore">
                                                                    <input type="text"
                                                                           class="form-control"
                                                                           name="uf"
                                                                           autocomplete="off"
                                                                           v-model="model.uf"
                                                                           maxlength="2" @keypress="textoPadrao($event)" onpaste="return false" />
                                                                </div>
                                                                <div v-if="bloquearEscolaCNAStore">
                                                                    <p>{{model.uf}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="w-100 pr-3">
                                                                <button type="button"
                                                                        class="btn btn-danger btn-round mt-3 ml-3"
                                                                        @click="dialogAlteraSenha = true">
                                                                    Alterar Senha
                                                                </button>
                                                                <button type="button"
                                                                        class="btn btn-primary btn-round float-right mt-3 ml-3"
                                                                        @click="executeEdit(model)">
                                                                    Confirmar
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-tab>
                                            <b-tab title="Dados de Acesso">
                                                <div class="row pl-md-3 mt-3">
                                                    <div class="form-group form-group-custom col-md-6">
                                                        <label for="nome" class="bmd-label-floating">Nome Completo</label>
                                                        <input type="text"
                                                               class="form-control"
                                                               name="nome"
                                                               autocomplete="off"
                                                               v-model="model.nome"
                                                               disabled />
                                                    </div>
                                                    <div class="form-group form-group-custom col-md-6">
                                                        <label for="userName" class="bmd-label-floating">Username</label>
                                                        <input type="text"
                                                               class="form-control"
                                                               name="userName"
                                                               autocomplete="off"
                                                               v-model="model.userName" />
                                                    </div>
                                                    <div class="form-group form-group-custom col-md-6">
                                                        <label for="cpF_CNPJ" class="bmd-label-floating">CPF ou CNPJ</label>
                                                        <input type="text"
                                                               class="form-control"
                                                               name="cpF_CNPJ"
                                                               autocomplete="off"
                                                               v-model="model.cpF_CNPJFormatado"
                                                               disabled />
                                                    </div>
                                                    <div class="form-group form-group-custom col-md-6">
                                                        <label for="email" class="bmd-label-floating">E-mail</label>
                                                        <input type="email"
                                                               class="form-control"
                                                               name="email"
                                                               autocomplete="off"
                                                               v-model="model.email" />
                                                    </div>
                                                </div>
                                                <div class="w-100 pr-3">
                                                    <button type="button"
                                                            class="btn btn-danger btn-round mt-3 ml-3"
                                                            @click="dialogAlteraSenha = true">
                                                        Alterar Senha
                                                    </button>
                                                    <button type="button"
                                                            class="btn btn-primary btn-round float-right mt-3 ml-3"
                                                            @click="executeEdit(model)">
                                                        Confirmar
                                                    </button>
                                                </div>
                                            </b-tab>
                                        </b-tabs>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <!--Fim-->
                    </div>
                </div>
            </div>
        </div>

        <b-modal :no-close-on-backdrop="true"
                 size="lg"
                 :no-close-on-esc="true"
                 centered
                 v-model="dialogAlteraSenha"
                 :hide-footer="true"
                 title="Alterar Senha">
            <nova-senha :id="id"
                        v-if="dialogAlteraSenha"
                        @on-saved="hideAll()"
                        @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true"
                 size="lg"
                 :no-close-on-esc="true"
                 centered
                 v-model="dialogConfirmarSenha"
                 :hide-footer="true"
                 title="Confirmar Senha">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="confirmacao">
                                Para realizar a alteração de e-mail ou username, é necessário a
                                confirmação da senha
                            </label>
                            <input type="password"
                                   class="form-control"
                                   name="confirmarSenha"
                                   v-model="model.confirmarSenha"
                                   placeholder="Informe a Confirmação de Senha"
                                   required />
                        </div>
                    </div>
                    <div class="row col-md-12 mt-3">
                        <div class="col-6">
                            <button type="button"
                                    class="btn btn-danger border-primary rounded-pill previous-button px-4"
                                    @click="hideAll()">
                                Voltar
                            </button>
                        </div>
                        <div class="col-6 text-right">
                            <button type="button"
                                    class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4"
                                    @click="confirmarSenha(model)">
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>



<script>
    import { Api } from "@/common/api";
    import base from "@/common/base";
    import novaSenha from "./novasenha";

    export default {
        name: "pessoa-cna-edit",
        mixins: [base],
        components: { novaSenha },
        data: () => ({
            id: null,
            form: "pessoa-cna-form-edit",

            model: {
                cep: "",
                numero: "",
                complemento: "",
                bairro: "",
                foto: "",
                confirmarSenha: "",
            },
            bloquearEscolaCNAStore: false,
            dialogAlteraSenha: false,
            dialogConfirmarSenha: false,
            emailOld: "",
            userNameOld: "",
            foto: null,
            file: null,
            isValidCPFCNPJ: true,
        }),
        methods: {
            confirmarSenha(model) {
                if (this.formValidate() == false) return;
                this.showLoading();

                new Api("pessoacna").put(model).then(
                    (data) => {
                        this.defaultSuccessResult("Seu cadastro foi atualizado com sucesso");
                        this.get();
                        this.hideAll();
                    },
                    (err) => {
                        this.defaultErrorResult(err);
                    }
                );
            },

            hideAll() {
                this.dialogAlteraSenha = false;
                this.dialogConfirmarSenha = false;
            },

            textoPadrao(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode >= 33 && charCode <= 47) || (charCode >= 58 && charCode <= 64)
                    || (charCode >= 91 && charCode <= 93) || (charCode >= 123 && charCode <= 125)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            buscarCep() {
                const _cep = this.model.cep;
                if (_cep && _cep.length == 9) {
                    new Api(
                        "log_logradouro/GetDataListCustom",
                        "https://target-cep.azurewebsites.net/api/"
                    )
                        .get({ cep: _cep })
                        .then((data) => {
                            if (data.DataList == null || data.DataList.length < 1)
                                data.DataList = [
                                    {
                                        bairro: "",
                                        cep: "",
                                        cidade: "",
                                        logradouro: "",
                                        uf: "",
                                        tipo: "",
                                    },
                                ];

                            var item = data.DataList[0];

                            this.model.bairro = item.bairro;
                            this.model.cidade = item.cidade;
                            this.model.uf = item.uf;
                            this.model.rua = item.logradouro;
                        });
                }
            },

            validaTamanho() {
                this.foto = this.$refs.file.$refs.input.files[0];
                if (this.foto) {
                    if (this.foto.size / 1024 > 1024) {
                        this.$eventHub.$emit("show-notification", {
                            type: "error",
                            title: "Atenção",
                            text: "Arquivo da imagem do Produto não pode ser maior que 1Mb.",
                        });
                        this.$refs.file.reset();
                        return;
                    } else {
                        var reader = new FileReader();
                        reader.readAsDataURL(this.foto);
                        setTimeout(() => {
                            this.model.foto = reader.result;
                        }, 500);
                    }
                }
            },
            executeEdit(model) {

                if (this.formValidate() == false) {
                    this.defaultErrorResult('Verifique a aba "Meus Dados"');
                    return
                };

                if (
                    this.model.email != this.emailOld ||
                    this.model.userName != this.userNameOld
                ) {
                    this.dialogConfirmarSenha = true;
                } else {

                    this.showLoading();

                    new Api("pessoacna").put(model).then(
                        (data) => {
                            this.defaultSuccessResult(
                                "Seu cadastro foi atualizado com sucesso"
                            );
                            this.get();
                        },
                        (err) => {
                            this.defaultErrorResult(err);
                        }
                    );
                }
            },

            formValidate() {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                return _valid;
            },

            get() {
                this.showLoading();
                new Api("pessoacna").get({ id: this.id }).then(
                    (data) => {
                        this.hideLoading();
                        this.model = data.data;
                        //console.log("dados", this.model);
                        if (this.model) {
                            // console.log("tamanho", this.model.cpF_CNPJ.length);
                            if (this.model.cpF_CNPJ.length > 11)
                                this.bloquearEscolaCNAStore = true;
                        }

                        if (this.model.email) {
                            var emailJson = JSON.stringify(this.model.email);
                            this.emailOld = JSON.parse(emailJson);
                        }
                        if (this.model.userName) {
                            var userNameJson = JSON.stringify(this.model.userName);
                            this.userNameOld = JSON.parse(userNameJson);
                        }
                    },
                    (err) => {
                        this.defaultErrorResult(err);
                    }
                );
            },
        },

        mounted() {
            this.id = this.$route.params.id;
            this.get();
        },
    };
</script>

<style lang="scss">
    .back-perfil {
        font-family: "Roboto", sans-serif;

        .font-cna label {
            color: #034182;
            font-size: 14px;
            margin-bottom: 0;
            font-weight: bold;
        }

        a {
            color: rgba($color: #000000, $alpha: 0.5);
        }

        .tabs {
            .nav-tabs {
                display: flex;
                justify-content: space-between;
                flex-direction: row;

                .nav-item {
                    display: flex;
                    justify-content: center;
                    width: 50%;

                    a {
                        width: 100%;
                        text-align: center;

                        &:hover {
                            background-color: #f8f9fa !important;
                            color: #034182;
                        }

                        &.active {
                            border: 0;
                            border-bottom: solid 1px #ff385d;
                        }
                    }
                }
            }
        }
    }
</style>